export default "__VITE_ASSET__CDOlS$gO__"